module.exports = __webpack_public_path__ + "static/media/p208ulse.fa29defa.jpg";